import { StripeEnv } from '../../util/enums';
import { StripeError } from './errors';
import { vaultRequest } from './request';

const SET_PAYOUT_FREQUENCY_STRIPE_CONNECT_ACCOUNT_MUTATION = `
mutation VaultStripeConnectAccountPayoutFrequencySet(
  $payoutInterval: VaultPayoutInterval!
  $stripeConnectAccountId: String!
  $stripeEnv: VaultStripeEnv
  $orgId: ID
) {
  response: vaultStripeConnectAccountPayoutFrequencySet(
    payoutInterval: $payoutInterval
    stripeConnectAccountId: $stripeConnectAccountId
    stripeEnv: $stripeEnv
    orgId: $orgId
  ) {
    errors {
      message
      type
    }
    success
  }
}
`;
export const setStripeConnectAccountPayoutFrequency = async (
  stripeConnectAccountId: string,
  payoutInterval: string,
  stripeEnv?: StripeEnv,
  orgId?: string,
): Promise<boolean> => {
  const setFrequencyConnectRes = await vaultRequest(
    SET_PAYOUT_FREQUENCY_STRIPE_CONNECT_ACCOUNT_MUTATION,
    {
      stripeConnectAccountId,
      payoutInterval,
      stripeEnv,
      orgId,
    },
  );
  const frequencyStripeConnectResJson = await setFrequencyConnectRes.json();
  if (
    frequencyStripeConnectResJson.errors &&
    frequencyStripeConnectResJson.errors.length > 0
  ) {
    throw new StripeError(
      'Could not set Payout Frequency of Stripe Connect Account',
      frequencyStripeConnectResJson.errors[0],
    );
  }
  return frequencyStripeConnectResJson.data.response.success;
};
